module.exports = __webpack_public_path__ + "img/рз_47.2e975d5a.png";